import { useTranslation } from "react-i18next";

const getComplianceItems = (t: (key: string) => string) => [
  { icon: "ri-medicine-bottle-line", label: t("complianceItem1"), desc: t("complianceItem1Desc") },
  { icon: "ri-flask-line", label: t("complianceItem2"), desc: t("complianceItem2Desc") },
  { icon: "ri-restaurant-2-line", label: t("complianceItem3"), desc: t("complianceItem3Desc") },
  { icon: "ri-capsule-line", label: t("complianceItem4"), desc: t("complianceItem4Desc") },
  { icon: "ri-home-3-line", label: t("complianceItem5"), desc: t("complianceItem5Desc") },
  { icon: "ri-file-paper-2-line", label: t("complianceItem6"), desc: t("complianceItem6Desc") },
];

export default function ServiceCompliance() {
  const { t } = useTranslation();
  const complianceItems = getComplianceItems(t);

  return (
    <section id="service-2" className="bg-[#f5f8ff] py-20 lg:py-24">
      <div className="w-full px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 flex items-center justify-center bg-[#0A1628] rounded-xl">
                <i className="ri-shield-star-line text-2xl text-white" />
              </div>
              <span className="text-xs font-semibold tracking-widest uppercase text-[#00C2C2]">{t("complianceServiceNum")}</span>
            </div>
            <h2 className="text-4xl font-bold text-[#0A1628] leading-tight">
              {t("complianceTitle")}<br />{t("complianceSubtitle")}
            </h2>
          </div>
          <p className="text-gray-600 text-base max-w-md leading-relaxed">
            {t("complianceDesc")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {complianceItems.map((item) => (
            <div key={item.label} className="bg-white rounded-2xl p-6 border border-gray-100 hover:border-[#00C2C2]/30 transition-all group">
              <div className="w-12 h-12 flex items-center justify-center bg-[#f8fafc] rounded-xl mb-4 group-hover:bg-[#0A1628]/10 transition-colors">
                <i className={`${item.icon} text-2xl text-[#00C2C2]`} />
              </div>
              <h3 className="text-[#0A1628] font-bold text-base mb-2">{item.label}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10">
          <a
            href="/contact"
            className="inline-flex items-center gap-2 bg-[#00C2C2] text-white text-sm font-bold px-7 py-3.5 rounded-full hover:bg-[#00AAAA] transition-all whitespace-nowrap cursor-pointer"
          >
            {t("complianceCta")} <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}
